import { Component, Input, OnInit } from '@angular/core';
interface KpiCardData {
  value: number | string;
  label: string;
  icon: string;
}
@Component({
  selector: 'app-kpi-indicators',
  templateUrl: './kpi-indicators.component.html',
  styleUrls: ['./kpi-indicators.component.scss'],
  standalone :false
})
export class KpiIndicatorsComponent implements OnInit {
  @Input() card: KpiCardData [] = [];
  constructor() { }
  ngOnInit(): void {

  }
}
